import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { WarehouseForm } from "@/features/warehouses/warehouse-form";

import { Button } from "@mui/material";

export const EditWarehouse = () => {
  const { warehouseId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchWarehouse = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: {
              name,
              description,
              damagedGoodsWarehouse,
              status,
              warehouseAddress: {
                address,
                city,
                country,
                postalCode,
                province,
              },
              warehouseOutlets,
            },
          },
        } = await apiClient.get(`warehouses/${warehouseId}`, {
          params: {
            withAddress: true,
            withUsers: true,
            withOutlets: true,
          },
        });

        setDefaultValues({
          name,
          description,
          damagedGoodsWarehouse,
          status,
          address,
          city,
          country,
          postalCode,
          province,
          warehouseOutlets: warehouseOutlets.map((warehouseOutlet) => ({
            outletId: warehouseOutlet.outletId,
            outletName: warehouseOutlet.outlet.name,
            type: warehouseOutlet.type,
          })),
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal memperbarui gudang")
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchWarehouse();
  }, [showSnackbar, warehouseId]);

  const handleSubmit = async (formData) => {
    try {
      await apiClient.put(`warehouses/${warehouseId}`, formData);
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui gudang")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Ubah Gudang"
      breadcrumbs={[
        { title: "Gudang", path: "/inventory/warehouses" },
        { title: "Ubah" },
      ]}
    >
      <WarehouseForm
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isLoading }) => (
          <Button type="submit" variant="contained" loading={isLoading}>
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
